/* Brielle Diamonds — site behaviour (hover states, scroll reveal, header, bag, accordions, carousels) */
(function () {
  'use strict';
  var Br = window.Br = window.Br || {};

  /* ---------- Hover states: the design declares them per element ---------- */
  var hoverSheet, hoverSeen = {};
  function hoverClass(css) {
    var h = 0;
    for (var i = 0; i < css.length; i++) h = ((h << 5) - h + css.charCodeAt(i)) | 0;
    var cls = 'brh' + (h >>> 0).toString(36);
    if (!hoverSeen[cls]) {
      hoverSeen[cls] = 1;
      if (!hoverSheet) {
        var st = document.createElement('style');
        st.setAttribute('data-br-hover', '');
        document.head.appendChild(st);
        hoverSheet = st.sheet;
      }
      var decl = css.split(';').map(function (d) { d = d.trim(); return d ? d.replace(/\s*!important\s*$/, '') + ' !important' : ''; }).filter(Boolean).join(';');
      try { hoverSheet.insertRule('.' + cls + ':hover{' + decl + '}', hoverSheet.cssRules.length); } catch (e) {}
    }
    return cls;
  }
  Br.applyHover = function (root) {
    (root || document).querySelectorAll('[data-hover]').forEach(function (el) {
      if (el.__brh) return;
      el.__brh = 1;
      el.classList.add(hoverClass(el.getAttribute('data-hover')));
    });
  };

  /* ---------- Scroll reveal ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.08 }) : null;
  Br.applyReveal = function (root) {
    (root || document).querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  };

  /* ---------- Money ---------- */
  Br.money = function (cents) {
    var fmtEl = document.querySelector('[data-br-money]');
    var format = '${{amount}}';
    try { if (fmtEl) format = JSON.parse(fmtEl.textContent) || format; } catch (e) {}
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var val = parts[1] === '00' ? whole : whole + '.' + parts[1];
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  Br.esc = esc;

  /* ---------- Header: mega menus + mobile nav ---------- */
  function initHeader(root) {
    var header = (root || document).querySelector('[data-br-menu-root]');
    if (!header || header.__br) return;
    header.__br = 1;
    var megas = header.querySelectorAll('[data-br-mega]');
    function closeAll() { megas.forEach(function (m) { m.hidden = true; }); }
    header.querySelectorAll('[data-br-menu-open]').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        closeAll();
        var m = header.querySelector('[data-br-mega="' + a.getAttribute('data-br-menu-open') + '"]');
        if (m && window.innerWidth >= 1180) m.hidden = false;
      });
    });
    header.addEventListener('mouseleave', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    var tog = header.querySelector('[data-br-mnav-toggle]'), nav = header.querySelector('[data-br-mnav]');
    if (tog && nav) tog.addEventListener('click', function () {
      nav.hidden = !nav.hidden;
      tog.setAttribute('aria-expanded', nav.hidden ? 'false' : 'true');
    });
  }

  /* ---------- Bag drawer (Shopify cart) ---------- */
  var bag = {};
  function bagEls() {
    bag.root = document.querySelector('[data-br-bag]');
    bag.overlay = document.querySelector('[data-br-bag-overlay]');
    return !!bag.root;
  }
  Br.openBag = function () {
    if (!bagEls()) { window.location.href = '/cart'; return; }
    bag.root.style.transform = 'translateX(0)';
    bag.root.setAttribute('aria-hidden', 'false');
    bag.overlay.style.opacity = '1';
    bag.overlay.style.pointerEvents = 'auto';
    Br.refreshBag();
  };
  Br.closeBag = function () {
    if (!bagEls()) return;
    bag.root.style.transform = 'translateX(105%)';
    bag.root.setAttribute('aria-hidden', 'true');
    bag.overlay.style.opacity = '0';
    bag.overlay.style.pointerEvents = 'none';
  };
  function renderBag(cart) {
    if (!bagEls()) return;
    var count = cart.item_count || 0;
    document.querySelectorAll('[data-br-bag-count]').forEach(function (el) { el.textContent = count ? String(count) : ''; });
    var tc = bag.root.querySelector('[data-br-bag-total-count]'); if (tc) tc.textContent = count;
    bag.root.querySelector('[data-br-bag-empty]').hidden = count > 0;
    bag.root.querySelector('[data-br-bag-full]').hidden = count === 0;
    bag.root.querySelector('[data-br-bag-subtotal]').textContent = Br.money(cart.total_price || 0);
    var html = (cart.items || []).map(function (it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title'; }).map(function (o) { return o.value; });
      if (it.properties) Object.keys(it.properties).forEach(function (k) { if (k.charAt(0) !== '_' && it.properties[k]) opts.push(k === 'Ring size' ? 'Size ' + it.properties[k] : it.properties[k]); });
      var src = (it.featured_image && it.featured_image.url) || it.image || '';
      var img = src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
      return '<div style="display:grid;grid-template-columns:96px minmax(0,1fr);gap:20px;padding:24px 0;border-bottom:1px solid #E1E1E1;">' +
        '<a href="' + esc(it.url) + '" style="display:block;width:96px;height:120px;background:#F1F0EE;overflow:hidden;">' +
        (img ? '<img src="' + esc(img) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">' : '') + '</a>' +
        '<div style="display:flex;flex-direction:column;min-width:0;">' +
        '<a href="' + esc(it.url) + '" style="font-family:\'Cormorant Garamond\',serif;font-size:18px;line-height:1.25;color:#000;text-decoration:none;text-wrap:pretty;">' + esc(it.product_title) + '</a>' +
        '<div style="margin-top:8px;font-size:12px;color:#6A6C77;line-height:1.7;">' + esc(opts.join(' · ')) + '</div>' +
        '<div style="margin-top:auto;padding-top:14px;display:flex;justify-content:space-between;align-items:center;">' +
        '<div style="display:flex;align-items:center;border:1px solid #E1E1E1;">' +
        '<button type="button" data-br-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease" style="width:34px;height:34px;background:none;border:0;cursor:pointer;font-size:15px;color:#000;">−</button>' +
        '<span style="width:24px;text-align:center;font-size:13px;">' + it.quantity + '</span>' +
        '<button type="button" data-br-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase" style="width:34px;height:34px;background:none;border:0;cursor:pointer;font-size:15px;color:#000;">+</button>' +
        '</div><div style="font-size:13px;">' + Br.money(it.final_line_price) + '</div></div>' +
        '<button type="button" data-br-qty="' + esc(it.key) + '" data-q="0" style="align-self:flex-start;margin-top:10px;background:none;border:0;padding:0;cursor:pointer;font-family:\'Jost\',sans-serif;font-weight:300;font-size:11px;letter-spacing:0.14em;color:#6A6C77;text-decoration:underline;text-underline-offset:3px;">REMOVE</button>' +
        '</div></div>';
    }).join('');
    bag.root.querySelector('[data-br-bag-items]').innerHTML = html;
  }
  Br.refreshBag = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderBag).catch(function () {});
  };
  function initBag() {
    if (!bagEls() || bag.root.__br) return;
    bag.root.__br = 1;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-br-bag-open]')) { e.preventDefault(); Br.openBag(); return; }
      if (e.target.closest('[data-br-bag-close]') || e.target.closest('[data-br-bag-overlay]')) { Br.closeBag(); return; }
      var q = e.target.closest('[data-br-qty]');
      if (q) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: q.getAttribute('data-br-qty'), quantity: Math.max(0, parseInt(q.getAttribute('data-q'), 10) || 0) }) })
          .then(function (r) { return r.json(); }).then(renderBag).catch(function () {});
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Br.closeBag(); });
    if (document.querySelector('[data-br-bag-full]:not([hidden])')) Br.refreshBag();
  }

  /* ---------- Accordions (one open at a time, like the design) ---------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('[data-br-acc]').forEach(function (group) {
      if (group.__br) return;
      group.__br = 1;
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-br-acc-btn]');
        if (!btn || !group.contains(btn)) return;
        var item = btn.closest('[data-br-acc-item]');
        var wasOpen = !item.querySelector('[data-br-acc-body]').hidden;
        group.querySelectorAll('[data-br-acc-item]').forEach(function (it) {
          it.querySelector('[data-br-acc-body]').hidden = true;
          it.querySelector('[data-br-acc-sign]').textContent = '+';
        });
        if (!wasOpen) {
          item.querySelector('[data-br-acc-body]').hidden = false;
          item.querySelector('[data-br-acc-sign]').textContent = '−';
        }
      });
    });
  }

  /* ---------- Accessibility button: larger text ---------- */
  function initA11y() {
    var b = document.querySelector('[data-br-a11y]');
    if (!b || b.__br) return;
    b.__br = 1;
    var on = false;
    try { on = localStorage.getItem('br-large-text') === '1'; } catch (e) {}
    function apply() { document.documentElement.classList.toggle('br-large-text', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    apply();
    b.addEventListener('click', function () { on = !on; try { localStorage.setItem('br-large-text', on ? '1' : '0'); } catch (e) {} apply(); });
  }

  /* ---------- Videos: keep muted autoplay going ---------- */
  function initVideos(root) {
    (root || document).querySelectorAll('video[data-br-autoplay], [data-br-video] video').forEach(function (v) {
      if (v.__br) return;
      v.__br = 1;
      v.muted = true; v.loop = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      v.addEventListener('ended', function () { v.currentTime = 0; var q = v.play(); if (q && q.catch) q.catch(function () {}); });
    });
  }

  Br.init = function (root) {
    Br.applyHover(root); Br.applyReveal(root); initHeader(root); initAccordions(root); initVideos(root);
    initBag(); initA11y();
    (Br.modules || []).forEach(function (fn) { try { fn(root || document); } catch (e) { if (window.console) console.error(e); } });
  };
  Br.modules = Br.modules || [];
  Br.register = function (fn) { Br.modules.push(fn); if (Br.ready) { try { fn(document); } catch (e) {} } };

  function boot() { Br.ready = true; Br.init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { Br.init(e.target); });
})();
